import React, { Component } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';

class AiringTodayTvChart extends Component {
  componentDidMount() {
    this.props.onFetchAringToday();
  }

  shouldComponentUpdate(netxProps) {
    return netxProps.aringToday !== this.props.aringToday;
  }

  render() {
    return (
      <ResponsiveContainer width="99%" height="99%">
        <BarChart
          width={500}
          height={300}
          data={this.props.aringToday}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="title" hide={true} />
          <YAxis
            domain={[dataMin => Math.abs(dataMin) - 1, dataMax => dataMax + 1]}
            scale={'pow'}
          />
          <Tooltip />
          <Legend />
          <Bar dataKey="rating" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = state => ({
  aringToday: state.tvReducer.aringToday
});

const mapDispatchToProps = dispatch => ({
  onFetchAringToday: () => dispatch(actions.fetchAringToday())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiringTodayTvChart);
